import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
import { findBindPatient } from "@/api/wxConfig.js";

import home from "./home";
import preachInvestigateCollect from "./preachInvestigateCollect";
import careFamilyMembers from "./careFamilyMembers";
import deptKnowledge from "./deptKnowledge";
import knowledgeEncyclopedias from "./knowledgeEncyclopedias";
import preachInvestigate from "./preachInvestigate";
import formPreview from "./formPreview";

const routes = [
	{
		path: "*",
		redirect: {
			path: "/wxLogin"
		}
	},
	{
		path: "/wxLogin",
		component: resolve => require.ensure([], () => resolve(require("@/views/wxLogin/wxLogin")), "wxLogin"),
		meta: {
			title: '领翼信息'
		}
	},
	/**
     * 满意度调查表单
     */
	{
		path: '/satisfied',
		component: resolve => require.ensure([], () => resolve(require("@/views/satisfied")), "satisfied"),
		meta: {
			title: '满意度问卷调查'
		}
	},
    /**
     * 调查/随访表单
     */
	{
		path: '/postlist',
		component: resolve => require.ensure([], () => resolve(require("@/views/postList")), "postList"),
		meta: {
			title: '随访表单'
		}
	},
    /**
     * 宣教文章
     */
	{
		path: '/education',
		component: resolve => require.ensure([], () => resolve(require("@/views/education")), "education"),
		meta: {
			title: '宣教文章'
		}
	},
	/**
	 * 初始的登录页
 	*/
	{
		path: "/login",
		name: "login",
		component: resolve => require.ensure([], () => resolve(require("@/views/login/login")), "login"),
		meta: {
			title: "绑定个人信息"
		}
	},
	/**
	 * 首页
 	*/
	...home,
	/**
	 * 首页Tab关怀 -> 科室知识页
 	*/
	...deptKnowledge,
	/**
	 * 首页Tab关怀 -> 点击进入的每一条li页
 	*/
	...preachInvestigate,
	/**
	 * 首页Tab关怀 -> 关注家属页
 	*/
	...careFamilyMembers,
	/**
	 * 首页Tab关怀 -> 知识百科页
 	*/
	...knowledgeEncyclopedias,
	/**
	 * 首页Tab我的
 	*/
	...preachInvestigateCollect,
	/**
	 * 表单预览
	*/
	...formPreview
];

/**
 * 写 title
*/
const writeTitle = function (to) {
	window.document.title = to.meta.title;
}

const routerMap = new Router({
	// mode: process.env.NODE_ENV === "development" ? "history" : "history",
	mode: "history",
	scrollBehavior: () => ({
		y: 0
	}),
	routes
});
routerMap.beforeEach((to, from, next) => {
	if(to.path === "/login"){
		var hrefQuery = to.query;
		if(hrefQuery.idNo && hrefQuery.openId){
            findBindPatient(
                {
                    idCard: hrefQuery.idNo,
                    openId:hrefQuery.openId,
					patientId:null
                },
                "自动登录中..."
            ).then(res => {
                if (res.code == 200) {
                    //本地存openId
                    if(res.result){
						window.localStorage.setItem("openId", hrefQuery.openId);
						window.localStorage.setItem("patientId", res.result.patientId);
						window.localStorage.setItem("data", JSON.stringify(res.result));
					}
					next({path:"/home"});
                } else {
					Toast(res.message);
					next();
                }
            }).catch(error => {
				next();
            });
        }else{
			next();
		}
	}else{
		next();
	}
});

routerMap.afterEach((to, from) => {
	writeTitle(to);
});

export default routerMap;



// WEBPACK FOOTER //
// ./src/router/index.js